<template>
  <div class="eol-header-box">
    <div class="left-box">
      <a :href="getHomeUrl()" target="_self"><img v-if="schoolInfo && schoolInfo.school_logo" :src="schoolInfo.school_logo_light" class="logo-img"></a>
      <div class="eol-system-name">{{ appsUserInfo.project_name }}</div>
    </div>
    <div class="middle-buttons">
      <div class="button" :class="{active:(pathname.indexOf('/student')>-1&&!isTeacher) || pathname.indexOf('/school')>-1 && isTeacher}" @click="headerPush(2)">{{isTeacher?'实践教学管理平台':'我的实践活动'}}</div>
      <div class="button" :class="{active:pathname.indexOf('/worksshow')>-1}" @click="headerPush(1)">微电影及大学生讲思政课</div>
    </div>
    <div class="right-box">
      <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false" @click="menuOpen = !menuOpen">
        <div class="mine-lines">
          <div class="user-imgs-box"></div>
          <span>{{appsUserInfo.name}}</span>
        </div>
        <ul @mouseleave="menuOpen = false" class="eol-submine-box">
          <li class="submine-items">
            <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`" target="_blank">信息服务中心</a>
          </li>
          <li class="submine-items">
            <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`" target="_blank">个人信息</a>
          </li>
          <li class="submine-items">
            <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`" target="_blank">修改密码</a>
          </li>
          <li class="submine-items" @click="logoutEvents"><a href="javascript:;">退出登录</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
axios.defaults.withCredentials = true; //允许跨域携带cookies
import services from "../assets/js/services"
export default {

  name: "Header",
  data () {
    return {
      services,
      menuOpen: false,
      school_code: localStorage.getItem("schoolCode"),
      fromSchool: null,
      isTeacher: false,
      pathname: window.location.pathname
    }
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
      schoolInfo: state => state.appsLogin.schoolInfo,
    }),
  },
  async mounted () {
    if (!this.schoolInfo) this.getLoginSchoolInfo({ school_code: this.school_code })

    if (!this.appsUserInfo && !this.appsUserInfo.school_code) {
      this.getAppsLoginUserInfo()
    }
    let userInfo = await this.appsUserInfo
    if (userInfo.user_type == 2 || (userInfo.user_type == 1 && (userInfo.role_ids == 1 || userInfo.role_ids == 2))) {
      //  教师
      this.isTeacher = true
    } else {
      this.isTeacher = false
      //  学生
    }

  },
  methods: {
    ...mapActions(["getAppsLoginUserInfo", "requestAppsLogout", "getLoginSchoolInfo"]),
    headerPush (flag) {
      if (flag == 1) {
        this.$router.push(`/${this.school_code}/worksshow`)
      } else {
        this.$router.push(this.isTeacher ? `/${this.school_code}/school` : `/${this.school_code}/student`)
      }
    },
    // 退出登录
    logoutEvents () {
      let that = this
      this.requestAppsLogout().then(res => {
        if (res.code == '0000') {
          if (!res.data || !res.data.redirect) {
            if (that.school_code) {
              window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${localStorage.getItem("schoolCode")}&format=html&from=${window.location.href}`, "_self");
            }
          }
        }
      })
    },
    getHomeUrl () {
      let userInfo = this.appsUserInfo
      if (userInfo.user_type == 2 || (userInfo.user_type == 1 && (userInfo.role_ids == 1 || userInfo.role_ids == 2))) {
        return `/${this.school_code}/school`
      } else {
        return `/${this.school_code}/student`
      }
    },

  }
}
</script>

<style lang="less" scoped>
.eol-header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 54px;
    background: #a82822;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 36px;
    z-index: 101;
    .left-box {
        display: flex;
        align-items: center;
        img {
            // max-height: 24px;
            width: 148px;
            height: auto;
            max-height: 60px;
        }
        .eol-system-name {
            margin-left: 25px;
            font-size: 16px;
            color: #ffffff;
            font-weight: bold;
        }
    }
    .middle-buttons {
        display: flex;
        align-items: center;
        transform: translateX(14vw);
        .button {
            background: #b84b3c;
            color: #ffeab3;
            border-radius: 4px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            padding: 0 12px;
            font-size: 14px;
            margin-right: 14px;
            &.active {
                background: #ffeab3;
                color: #892018;
            }
        }
    }
    .right-box {
        display: flex;
        align-items: center;
    }
}

.eol-header-box .eol-right-user {
    display: inline-block;
    vertical-align: top;
    max-width: 260px;
    position: relative;
}
.eol-header-box .eol-right-user.down .mine-lines:after {
    transform: rotate(0deg);
    transition: transform 0.3s;
}
.eol-header-box .eol-right-user.up .mine-lines:after {
    transform: rotate(180deg);
    transition: transform 0.3s;
}
.eol-header-box .eol-right-user .mine-lines:after {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background-image: url('../assets/image/common/down.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
}
.eol-header-box .eol-right-user .mine-lines {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #ffeab3;
}
.eol-header-box .eol-right-user .user-imgs-box {
    display: inline-block;
    width: 17px;
    height: 17px;
    vertical-align: middle;
    text-align: right;
    background: url('../assets/image/common/user-icon.png') no-repeat 50%;
    background-size: 100% auto;
}
.eol-header-box .eol-right-user .mine-lines span {
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 200px;
    margin: 0 21px 0 9px;
}
.eol-header-box .eol-right-user .eol-submine-box {
    background: #fff;
    border: 1px solid #e4e5ec;
    position: absolute;
    z-index: 1000;
    top: 50px;
    right: -10px;
    padding: 15px 15px 15px 20px;
    text-align: left;
    display: none;
    min-width: 125px;
    border-radius: 4px;
}
.eol-header-box .eol-right-user.down .eol-submine-box {
    display: none;
}
.eol-header-box .eol-right-user.up .eol-submine-box {
    display: block;
}
.eol-header-box .eol-right-user .submine-items {
    height: 30px;
    color: #71737b;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;
    list-style: none;
}
.eol-header-box .eol-right-user .submine-items a {
    display: block;
    width: auto;
    color: #71737b;
    cursor: pointer;
}
.eol-header-box .eol-right-user .submine-items a:hover {
    color: #a82822;
}
@media screen and (max-width: 1500px) {
    .eol-header-box .middle-buttons {
        transform: translateX(5vw);
    }
}
</style>